import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "ecuasuelo_cookie_consent";

const applyConsent = (consent) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  const gtag = function () {
    window.dataLayer.push(arguments);
  };
  gtag("consent", "update", {
    ad_storage: consent.ad ? "granted" : "denied",
    ad_user_data: consent.ad ? "granted" : "denied",
    ad_personalization: consent.ad ? "granted" : "denied",
    analytics_storage: consent.analytics ? "granted" : "denied",
  });
};

const CookieBanner = () => {
  const { t, lang } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const setConsent = (choice) => {
    const consent =
      choice === "accept"
        ? { analytics: true, ad: true, ts: Date.now() }
        : { analytics: false, ad: false, ts: Date.now() };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    } catch (e) {}
    applyConsent(consent);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-50 bg-slate-900 text-white border-t border-slate-700 shadow-2xl"
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="w-5 h-5 text-emerald-400 mt-0.5 shrink-0" />
          <div className="text-sm">
            <p className="font-semibold text-white mb-1">{t("cookie.title")}</p>
            <p className="text-slate-300 leading-relaxed">
              {t("cookie.text")}{" "}
              <Link
                to={`/${lang}/cookies`}
                data-testid="cookie-banner-policy-link"
                className="underline text-emerald-400 hover:text-emerald-300"
              >
                {t("cookie.policy_link")}
              </Link>
              .
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0 w-full md:w-auto">
          <button
            onClick={() => setConsent("decline")}
            data-testid="cookie-banner-decline-button"
            className="flex-1 md:flex-none px-4 py-2 text-sm rounded-md border border-slate-600 text-slate-200 hover:bg-slate-800"
          >
            {t("cookie.reject")}
          </button>
          <button
            onClick={() => setConsent("accept")}
            data-testid="cookie-banner-accept-button"
            className="flex-1 md:flex-none px-4 py-2 text-sm rounded-md bg-emerald-500 text-slate-900 font-semibold hover:bg-emerald-400"
          >
            {t("cookie.accept")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
